import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { GestockService } from '../services/gestock.service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
    selector: 'app-edit-boutique',
    templateUrl: './edit-boutique.component.html',
    styleUrls: ['./edit-boutique.component.css']
})
export class EditBoutiqueComponent implements OnInit {

    nouveauNom: string;
    ancienNom: string;
    caisseType: string = 'Automatique';
    ancienCaisseType: string = 'Automatique';
    idPoint: any;
    samacaabiyoonwii: any;
    loading = false;

    constructor(
        public dialogRef: MatDialogRef<EditBoutiqueComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private gestockService: GestockService,
        private snackBar: MatSnackBar
    ) {
        this.ancienNom = data.nompoint;
        this.nouveauNom = data.nompoint;
        this.caisseType = data.caisse_type || data.type_caisse || 'Automatique';
        this.ancienCaisseType = this.caisseType;
        this.idPoint = data.idPoint || data.id;
    }

    ngOnInit(): void {
        this.samacaabiyoonwii = sessionStorage.getItem("samacaabiyoonwii");
    }

    onSave(): void {
        const isNameValid = this.nouveauNom && this.nouveauNom.trim().length > 0;
        const isChanged = this.nouveauNom !== this.ancienNom || this.caisseType !== this.ancienCaisseType;

        if (isNameValid && isChanged) {
            this.loading = true;
            this.gestockService.updateBoutiqueName(this.samacaabiyoonwii, this.idPoint, this.nouveauNom, this.caisseType)
                .then(response => {
                    this.loading = false;
                    if (response && response.statutreq === 1) {
                        this.snackBar.open(response.message || 'Informations de la boutique mises à jour avec succès', 'Fermer', { duration: 3000 });
                        this.dialogRef.close(true);
                    } else {
                        this.snackBar.open(response?.message || 'Erreur lors de la modification', 'Fermer', { duration: 5000 });
                    }
                })
                .catch(error => {
                    this.loading = false;
                    this.snackBar.open('Erreur de connexion', 'Fermer', { duration: 5000 });
                    console.error(error);
                });
        }
    }

    onCancel(): void {
        this.dialogRef.close();
    }
}
